module.exports = __webpack_public_path__ + "static/media/p208model.f6a35e55.jpg";